import React from "react";
import { useState } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import Cookies from "universal-cookie";
import _ from "lodash";
import { toast } from "react-toastify";
import ApiAmusementService from "../../../core/api/api.amusementService";
import {
  IconComment,
  IconDisLike,
  IconLike,
  IconUserCustomer,
} from "../../../assets/icons";

//export const Comment = ({ userFullName, commentText, commentDate, totallyRank,commentid, likeDisLikeCount }) => {
export const Comment = (props) => {
  const cookies = new Cookies();
  const [likeCount, setLikeCount] = useState(props.likeCount);
  const [disLikeCount, setDisLikeCount] = useState(props.disLikeCount);
  const fnLikeOrDislike = (likeOrDislike) => async (event) => {
    // بررسی کوکی و درج در کوکی
    let likeOrDislikeOld = cookies.get(
      "amusementTestimoniallike_" + props.commentid
    );

    if (likeOrDislikeOld !== likeOrDislike) {
      // به‌روزرسانی کوکی
      cookies.set(
        "amusementTestimoniallike_" + props.commentid,
        likeOrDislike,
        { path: "/" }
      );

      // افزایش یا کاهش شمارش‌ها
      if (likeOrDislike === "Up") {
        setLikeCount((prevCount) => prevCount + 1);
        if (likeOrDislikeOld === "Down") {
          setDisLikeCount((prevCount) => prevCount - 1);
        }
      } else if (likeOrDislike === "Down") {
        setDisLikeCount((prevCount) => prevCount + 1);
        if (likeOrDislikeOld === "Up") {
          setLikeCount((prevCount) => prevCount - 1);
        }
      }

      // ارسال و درج در دیتا بیس
      let response =
        await ApiAmusementService.updateAmusementTestimonialLikeOrDislike({
          id: props.commentid,
          likeOrDislikeOld: likeOrDislikeOld,
          likeOrDislike: likeOrDislike,
        });
      // بررسی پاسخ و نمایش پیام
      if (response && response.message) {
        toast(response.message);
        setLikeCount(response.data.likeCount);
        setDisLikeCount(response.data.disLikeCount);
      }
    } else {
      toast.warn("نظر شما قبلا ثبت شده");
    }
  };

  return (
    <Card className="w-100 h-100 rounded-3 mb-3">
      <Card.Body className="pb-0">
        {isMobile ? (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <div className="small-svg border-bottom d-inline-flex pb-2">
                <IconUserCustomer fillColor="#0009" />
                <span className="ps-1 fs-08">{props.userFullName}</span>
              </div>
              {props.showType === "slider" ? (
                " "
              ) : props.totallyRank && props.totallyRank == 0 ? (
                ""
              ) : (
                <>
                  <div>
                    {props.totallyRank == 1
                      ? "خیلی بد"
                      : props.totallyRank == 2
                      ? "بد"
                      : props.totallyRank == 3
                      ? "متوسط"
                      : props.totallyRank == 4
                      ? "خوب"
                      : props.totallyRank == 5
                      ? "عالی"
                      : "-"}
                    <Badge
                      bg={props.totallyRank >= 3 ? "success" : "warning"}
                      className="text-085 ms-1 "
                    >
                      {props.totallyRank}
                    </Badge>
                  </div>
                </>
              )}
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-between">
            <div className="fw-bold">{props.userFullName}</div>
            <div>
              {props.totallyRank && props.totallyRank == 0 ? (
                ""
              ) : (
                <>
                  <div>
                    <span className="fs-075">
                      {props.totallyRank == 1
                        ? "خیلی بد"
                        : props.totallyRank == 2
                        ? "بد"
                        : props.totallyRank == 3
                        ? "متوسط"
                        : props.totallyRank == 4
                        ? "خوب"
                        : props.totallyRank == 5
                        ? "عالی"
                        : "-"}
                    </span>
                    <Badge
                      bg={props.totallyRank >= 3 ? "success" : "warning"}
                      className="text-085 ms-1 "
                    >
                      {props.totallyRank}
                    </Badge>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <p className="mt-3 fs-09 truncate text-align-justify">
          {props.commentText}
        </p>
        <div></div>
        {!isMobile &&
          Array.isArray(props?.children) &&
          props?.children.map((testimonialChild) => (
            <div className="p-3">
              <div className="fw-bold text-danger">
                <IconComment fillColor="#f80248" />
                <span className="ps-1">{testimonialChild.name}</span>
              </div>
              <div className="pt-2 text-align-justify">
                {testimonialChild.text}
              </div>
            </div>
          ))}
      </Card.Body>
      <Card.Footer className="border-top-0 text-xsmall bg-transparent text-muted">
        <Row>
          <Col>
            <div className="fs-085 text-black-06">{props.commentDate}</div>
          </Col>
          {!isMobile && (
            <Col className=" text-end d-flex justify-content-end">
              <div
                className=" text-medium  cursor-pointer px-1"
                onClick={fnLikeOrDislike("Up")}
              >
                <IconLike fillColor="#09a463" />
              </div>
              <div className="me-2 fw-bold">{likeCount}</div>

              <div
                className=" text-medium  cursor-pointer px-1"
                onClick={fnLikeOrDislike("Down")}
              >
                <IconDisLike fillColor="#f80248" />
              </div>
              {<div className="fw-bold">{disLikeCount}</div>}
            </Col>
          )}
        </Row>
      </Card.Footer>
    </Card>
  );
};
